import { z } from 'zod';

export const guideSortFields = ['name', 'language', 'tours', 'status'] as const;

export const guideAssignmentInput = z.object({
  view: z.enum(['future', 'past', 'all']).default('all'),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  limit: z.number().int().positive().max(100).default(20),
  offset: z.number().int().nonnegative().default(0),
  sortBy: z.enum(guideSortFields).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type GuideAssignmentInput = z.infer<typeof guideAssignmentInput>;

export const guideSchema = z.object({
  id: z.string(),
  fullName: z.string(),
  languages: z.array(z.string()),
});

export type Guide = z.infer<typeof guideSchema>;

// XT-310: a row carries only what the Guides table renders — the per-item
// array it used to ship was never displayed, and materialising it forced the
// whole windowed item set through Node before pagination could happen.
//
// `lastEndTime` / `lastOperationStatus` come from the LATEST-STARTING item in
// the window, not from `max(end_time)` / any other item. That is what the
// previous `items.at(-1)` read meant, and the table's "Date Range" column and
// status badge still depend on it.
export const guideAssignmentRowSchema = z.object({
  guide: guideSchema,
  tourCount: z.number(),
  firstStartTime: z.string().nullable(),
  lastEndTime: z.string().nullable(),
  lastOperationStatus: z.string().nullable(),
});

export type GuideAssignmentRow = z.infer<typeof guideAssignmentRowSchema>;

export const paginatedGuideAssignmentsSchema = z.object({
  data: z.array(guideAssignmentRowSchema),
  total: z.number(),
  offset: z.number(),
  limit: z.number(),
});

export type PaginatedGuideAssignments = z.infer<
  typeof paginatedGuideAssignmentsSchema
>;
